var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dilu-page",staticStyle:{"background-color":"#f4f6f9"}})
}
var staticRenderFns = []

export { render, staticRenderFns }